var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'button',
    `button_${_vm.type}`,
    { 'button_disabled': _vm.disabled || _vm.isLoading }
  ],attrs:{"type":_vm.tagType},on:{"click":_vm.onClick}},[_c('span',{staticClass:"button__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }